<template>
  <el-row>
    <el-col>
      <el-card shadow="never">
        <WebhookTable
          ref="teamsTable"
          :account-id="$route.params.accountId"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import WebhookTable from '@/components/Application/Manage/Account/WebhookTable'

export default {
  components: {
    WebhookTable
  },
  data () {
    return {
      actions: []
    }
  },
  mounted () {
    this.actions = this.$refs.teamsTable.actions
  }
}
</script>

<style>

</style>
